function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHabitIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.62
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 5,
    style: {
      fill: "#4fb84e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.71,89.5a10.08,10.08,0,0,1-7.1-2.94L15.4,67.36a10,10,0,0,1,14.2-14.2L39.76,63.33l29.17-48A10,10,0,0,1,86.08,25.75L50.29,84.67a10,10,0,0,1-7.38,4.76A9.77,9.77,0,0,1,41.71,89.5Z",
    style: {
      fill: "#fff",
      stroke: "#4fb84d",
      strokeMiterlimit: 10
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHabitIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/habit-icon.395540db.svg";
export { ForwardRef as ReactComponent };